<template lang="pug" src="./resales-list.pug"> </template>
<style lang="scss" src="./resales-list.scss" scoped></style>

<script>
    import Vue from 'vue';

    import {mapState} from 'vuex';
    import {validationMixin} from 'vuelidate';
    import {numeric, required} from 'vuelidate/lib/validators';

    import validate from '@/mixins/validate';
    import resalesListItem from '@/components/resales-list-item';

    export default {
    components: {
        'v-resales-list-item': resalesListItem
    },
    mixins: [validationMixin, validate],
    data: () => ({
        editModal: false,
        editedResale: null,
        requestProcessing: false,
        chosenOption: null
    }),
    validations: {
        editedResale: {
            compensation: {
                required,
                numeric
            },
            price: {
                required,
                numeric
            },
            delay: {
                required,
                numeric
            },
            compensationInPercent: {
                minValue: value => value >= 0,
                maxValue: value => value <= 100,
                required,
                numeric
            },
            priceInPercent: {
                minValue: value => value >= 0,
                maxValue: value => value <= 100,
                required,
                numeric
            }
        }
    },
    computed: {
        ...mapState({
            resalesItems: state => state.resales.items,
            brands: state => state.data.brands,
            optionClasses: state => state.data.optionClasses,
        }),
        extendedOptionClasses() {
            const classes = this.optionClasses.filter(it => {
                return ![
                    'Forced', 'PreOrder', 'Cashless',
                    'Delivery', 'Animals', 'Bonuses'
                ].includes(it.className);
            });

            return [{
                className: 'All',
                id: null,
                type: 'all'
            }, ...classes];
        },
        filteredOptions() {
            return this.extendedOptionClasses.filter(it => [null, this.option].includes(it.id));
        },
        headers() {
            return [''].concat(this.brandsWithoutActive).map(brand => ({
                text: Vue.filter('brand')(brand.id),
                sortable: false,
                align: 'center'
            }));
        },
        brandsWithoutActive() {
            return this.brands.filter(it => it.id !== this.brandId);
        },
        items() {
            const type = this.getType();
            return this.resalesItems.filter(it => it[type] == this.brandId);
        },
        dealer: {
            get () {
                return this.$store.state.resales.dealer;
            },
            set (value) {
                this.$store.commit('resales/SET_DEALER', value);
            }
        },
        brandId: {
            get () {
                return this.$store.state.resales.brandId;
            },
            set (value) {
                this.$store.commit('resales/SET_BRAND_ID', value);
            }
        },
        option: {
            get () {
                return this.$store.state.resales.option;
            },
            set (value) {
                this.$store.commit('resales/SET_OPTION', value);
            }
        }
    },
    created() {
        this.$store.dispatch('resales/getItems', null);
        this.$store.dispatch('data/getOptionClasses');

        this.$store.dispatch('data/getBrands').then(() => {
            this.$store.commit('resales/SET_BRAND_ID', this.brands[0].id);
        });
    },
    methods: {
        showResale(checkedBrandId, optionId, returnObj = false) {
            const checkedBrandType = this.getType(false);
            const activeBrandType = this.getType();
            const activeOptionType = this.extendedOptionClasses.find(it => it.id === optionId);

            const resale = this.items.find(it => {
                return it[checkedBrandType] == checkedBrandId && it[activeBrandType] && it.optionClassId === optionId;
            });

            if (!resale && !returnObj) {
                return null;
            } else if (!resale && returnObj) {
                return {
                    [checkedBrandType]: checkedBrandId,
                    [activeBrandType]: this.brandId,
                    optionClassId: activeOptionType.id,
                    compensation: 0,
                    price: 0,
                    compensationInPercent: 0,
                    priceInPercent: 0,
                    delay: 0
                };
            }

            return resale;
        },
        getType(forActive = true) {
            const types = {
                0: 'buyerId',
                1: 'dealerId'
            };

            return types[Number(forActive ? !this.dealer : this.dealer)];
        },
        getOptionClass(optionClassId) {
            this.$store.dispatch('resales/getItems', optionClassId);
        },
        cancel() {
            this.editedResale = null;
            this.editModal = false;

            this.$nextTick(() => {
                this.$v.editedResale.$reset();
            });
        },
        async edit(checkedBrandId, optionClassId) {
            this.editedResale = Object.assign({}, this.showResale(checkedBrandId, optionClassId, true));
            this.editModal = true;
        },
        async save() {
            if (this.$v.editedResale.$invalid) {
                return this.$v.editedResale.$touch();
            }

            if (this.requestProcessing) return;

            this.requestProcessing = true;

            await this.$store.dispatch('resales/save', this.editedResale).then(() => {
                this.$nextTick(() => {
                    this.requestProcessing = false;
                });
            });

            this.$nextTick(() => {
                this.cancel();
                this.$v.editedResale.$reset();
            });
        },
        async remove() {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            await this.$store.dispatch('resales/remove', this.editedResale).then(() => {
                this.$nextTick(() => this.requestProcessing = false);
            });

            this.cancel();
        }
    }
};
</script>
